import * as React from 'react';

export type StepContextType = {
  stickyFooter: boolean;
  isAtBottom: boolean;
};

export const StepContext = React.createContext<StepContextType>({} as any);
